import React from 'react';
import { Container, Row } from 'reactstrap';
import { ILoginPageLayoutProps } from '../../interfaces/Index';

import "./LoginPageLayout.scss";

const LoginPageLayout: React.FunctionComponent<ILoginPageLayoutProps> = (props) => {
  return (
    <Container fluid className="login-page-container full-height">
      <Row className="align-content-center full-height">
        <div className="login-page-content-block">
          {props.children}
        </div>
      </Row>
    </Container>
  );
};

export default LoginPageLayout;
